export { View as Tab2020 } from './view'
